import React from 'react';
import { Link } from 'react-router-dom';
import SectionHeader from '../components/ui/SectionHeader';
import FinalCTA from '../components/home/FinalCTA';

const highlights = [
  { icon: '📋', title: 'BRSR Structured Collection', desc: 'Nine principles of the National Guidelines on Responsible Business Conduct — essential and leadership indicators — mapped directly to BRSR\'s disclosure architecture. No re-mapping at year-end.' },
  { icon: '🏢', title: 'Multi-entity & Multi-plant', desc: 'Collect at individual plant level and roll up to entity and group. Supports the disaggregation SEBI-listed companies require for annual report submission.' },
  { icon: '👤', title: 'Role-based Data Ownership', desc: 'Named data owners per principle. Submissions tracked, reviewers assigned, approval status visible in real time across every entity.' },
  { icon: '🔍', title: 'Audit Trail', desc: 'Every submission, revision, and sign-off logged with identity and timestamp. Your BRSR auditor gets a complete, traceable evidence package.' },
  { icon: '⚡', title: 'Corporate Carbon Footprint', desc: 'Scope 1, 2, and 3 calculation aligned to GHG Protocol — integrated with your BRSR ESG data collection so energy and emissions data is collected once and used for both.' },
  { icon: '🔗', title: 'Sustainable Procurement', desc: 'Supplier ESG assessments and Scope 3 Category 1 data collection feeding directly into your BRSR supply chain disclosures.' },
];

export default function SolutionsIndia(): React.ReactElement {
  return (
    <main>
      <div className="page-hero">
        <div className="container">
          <span className="eyebrow" style={{ color: '#67E8F9', justifyContent: 'center', display: 'flex' }}>Solutions &mdash; India</span>
          <h1>BRSR compliance for SEBI-listed companies.</h1>
          <p>
            Actula structures your Business Responsibility and Sustainability Reporting collection
            directly around the nine BRSR principles &mdash; essential and leadership indicators &mdash;
            with full data trail for annual report submission and multi-entity consolidation for
            Indian conglomerates.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" className="btn btn-primary">Book a demo</Link>
            <Link to="/platform" className="btn btn-ghost-light">See full platform</Link>
          </div>
        </div>
      </div>

      <section className="section-pad" style={{ background: 'var(--white)' }}>
        <div className="container">
          <SectionHeader
            eyebrow="India — BRSR"
            title="Structured BRSR collection. No spreadsheets."
            description="SEBI's Business Responsibility and Sustainability Reporting framework requires listed companies to report across nine principles. Actula structures your data collection directly around BRSR's disclosure architecture."
          />

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
            {highlights.map((h, i) => (
              <div key={i} className="card">
                <span style={{ fontSize: '1.5rem', display: 'block', marginBottom: '12px' }}>{h.icon}</span>
                <h4 style={{ color: 'var(--navy)', marginBottom: '8px' }}>{h.title}</h4>
                <p style={{ color: 'var(--slate-500)', fontSize: '0.9375rem', lineHeight: 1.65 }}>{h.desc}</p>
              </div>
            ))}
          </div>

          <div style={{ marginTop: '48px', background: 'var(--slate-50)', borderRadius: '12px', padding: '32px 40px', borderLeft: '4px solid var(--teal)' }}>
            <h3 style={{ color: 'var(--navy)', marginBottom: '16px' }}>Active modules for India</h3>
            <div className="solutions-modules">
              {['ESG Data Collection & Reporting', 'Corporate Carbon Footprint', 'Sustainable Procurement'].map(m => (
                <span key={m} className="solutions-module-tag">{m}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      <FinalCTA />
    </main>
  );
}
